// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8fd3a0b1","455":"e4196793"}[chunkId] + ".chunk.js";
};